import React, { useEffect, useRef, useState } from 'react';
import MiniGenderProgressChart from './MiniGenderProgressChart';
import { pxToRem } from '../util';
import DiseaseChart from './DiseaseChart';

interface Item {
  name: string;
  total: number;
  value: number;
}

interface Props {
  data: Item[];
  rowHeight?: number; // 单条数据进度条高度
  visibleRows?: number; // 可视条目数
  scrollInterval?: number;
  height?: number | string;
}

const DiseaseScrollList: React.FC<Props> = ({
  data = [],
  rowHeight = 40,
  visibleRows = 5,
  scrollInterval = 2000,
  height,
}) => {
  const color = 'rgb(206, 234, 255)';
  const [hover, setHover] = useState(false);
  const [index, setIndex] = useState(0);

  const bodyRef = useRef<HTMLDivElement>(null);
  const timerRef = useRef<number | null>(null);

  const needScroll = data.length > visibleRows;
  const renderData = needScroll ? [...data, ...data] : data;

  // 自动滚动
  useEffect(() => {
    if (!needScroll) return;
    if (!hover) {
      timerRef.current = window.setInterval(() => {
        setIndex((prev) => prev + 1);
      }, scrollInterval);
    }
    return () => timerRef.current && clearInterval(timerRef.current);
  }, [hover, scrollInterval, needScroll]);

  // 无缝循环
  useEffect(() => {
    if (!needScroll) return;
    if (!bodyRef.current) return;

    if (index >= data.length) {
      const el = bodyRef.current;
      setTimeout(() => {
        el.style.transition = 'none';
        setIndex((prev) => prev - data.length);
        requestAnimationFrame(() => {
          el.style.transition = `transform 0.4s ease`;
        });
      }, 400);
    }
  }, [index, data.length, needScroll]);

  const translateY = -(index * (rowHeight + 24)); // 多加 20px 给名称行高度

  return (
    <div
      style={{
        overflow: 'hidden',
        position: 'relative',
        height: height ?? visibleRows * (rowHeight + 24),
      }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <div
        style={{ overflow: 'hidden', height: visibleRows * (rowHeight + 20) }}
      >
        <div
          ref={bodyRef}
          style={{
            transform: `translate3d(0, ${translateY}px, 0)`,
            transition: 'transform 0.4s ease',
          }}
        >
          {renderData.map((item, i) => (
            <div
              key={i}
              style={{
                display: 'flex',
                flexDirection: 'column', // 名称在上，进度条在下
                height: rowHeight + 24,
                padding: `${pxToRem(2)} ${pxToRem(12)}`,
                boxSizing: 'border-box',
              }}
            >
              {/* 名称单独一行 */}
              <div
                style={{
                  fontSize: pxToRem(14),
                  color,
                  whiteSpace: 'normal', // 可以换行
                  overflow: 'hidden',
                  height: 30,
                  lineHeight: '30px',
                  textOverflow: 'ellipsis',
                }}
                title={item.name}
              >
                {item.name}
              </div>

              {/* DiseaseChart */}
              <DiseaseChart value={item.value} totalValue={item.total} />
            </div>
          ))}
        </div>
      </div>

      {/* {needScroll && (
        <div
          style={{
            position: 'absolute',
            bottom: 6,
            right: 10,
            fontSize: 12,
            color: '#666',
            background: 'rgba(255,255,255,0.9)',
            padding: '2px 6px',
            borderRadius: 4,
          }}
        >
          {hover ? '暂停' : '滚动'} {(index % data.length) + 1} / {data.length}
        </div>
      )} */}
    </div>
  );
};

export default DiseaseScrollList;
